import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Portions of this file are Copyright 2021 Google LLC, and licensed under GPL2+. See COPYING.
import { useRef } from 'react';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
export default function HelpMenu({ className, style }) {
    const menuRef = useRef(null);
    return (_jsxs(_Fragment, { children: [_jsx(Menu, { style: style, className: className, model: [
                    {
                        label: "openscad-playground",
                        icon: 'pi pi-github',
                        url: 'https://github.com/openscad/openscad-playground/',
                        target: '_blank'
                    },
                    {
                        label: 'LICENSES',
                        icon: 'pi pi-info-circle',
                        url: 'https://github.com/openscad/openscad-playground/blob/main/LICENSE.md',
                        target: '_blank'
                    },
                    {
                        label: 'OpenSCAD Docs',
                        icon: 'pi pi-book',
                        url: 'https://openscad.org/documentation.html',
                        target: '_blank'
                    },
                    {
                        label: 'Customizer Syntax',
                        icon: 'pi pi-book',
                        url: 'https://en.wikibooks.org/wiki/OpenSCAD_User_Manual/Customizer',
                        target: '_blank'
                    },
                    {
                        label: 'OpenSCAD Cheatsheet',
                        icon: 'pi pi-palette',
                        url: 'https://openscad.org/cheatsheet/',
                        target: '_blank'
                    },
                ], popup: true, ref: menuRef }), _jsx(Button, { title: "Help & Licenses", rounded: true, text: true, icon: "pi pi-question-circle", onClick: (e) => menuRef.current && menuRef.current.toggle(e) })] }));
}
